import { render, staticRenderFns } from "./Prescribers.vue?vue&type=template&id=644919f5"
import script from "./Prescribers.vue?vue&type=script&lang=js"
export * from "./Prescribers.vue?vue&type=script&lang=js"
import style0 from "./Prescribers.vue?vue&type=style&index=0&id=644919f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports